import hyRequest from '@/service';
import {
  ISaleTotal,
  ISaleRatio,
  ISaleRtoAll,
  ISaleRevenue,
  ISaleRank
} from './type';

enum DashboardApi {
  getSaleTotal = '/sale/saleMoney',
  getSalePayRto = '/sale/payRto',
  getSaleRtoVolume = '/sale/saleRtoVolume',
  getSaleRtoAmount = '/sale/saleRtoAmount',
  getSaleRtoAll = '/saleData/stoneRate',
  getSaleHourRevenue = '/sale/saleHour',
  getSaleDayRevenue = '/sale/saleDay',
  getSaleRank = '/sale/saleRank'
}

// 获取销售统计
export function getSaleTotal(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<ISaleTotal>({
    url: DashboardApi.getSaleTotal,
    data
  });
}

// 获取各料类占比销量
export function getSaleRtoVolume(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<ISaleRatio>({
    url: DashboardApi.getSaleRtoVolume,
    data
  });
}

// 获取各料类占比金额
export function getSaleRtoAmount(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<ISaleRatio>({
    url: DashboardApi.getSaleRtoAmount,
    data
  });
}

// 获取各料类占比金额
export function getSaleRtoAll(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<ISaleRtoAll>({
    url: DashboardApi.getSaleRtoAll,
    data
  });
}

// 获取各时段营收趋势
export function getSaleHourRevenue(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<ISaleRevenue>({
    url: DashboardApi.getSaleHourRevenue,
    data
  });
}

// 获取各日营收趋势
export function getSaleDayRevenue(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<ISaleRevenue>({
    url: DashboardApi.getSaleDayRevenue,
    data
  });
}

// 获取支付方式占比
export function getSalePayRto(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<ISaleRatio>({
    url: DashboardApi.getSalePayRto,
    data
  });
}

// 获取消费排行榜
export function getSaleRank(data: {
  startTime: string;
  endTime: string;
  type: number;
}) {
  return hyRequest.post<ISaleRank>({
    url: DashboardApi.getSaleRank,
    data
  });
}
